import { flow, getRoot } from 'mobx-state-tree';

import { logger } from '@lusha/client-logger';

import { fetchUserCompanyInfo } from '../../../API/userAPI';

const Actions = self => ({
  loadInfo: flow(function* loadCompanyInfo() {
    const { user } = getRoot(self);

    if (!self.isLoaded) {
      logger.info(`Fetching ${user.email} company's data`);

      try {
        const response = yield fetchUserCompanyInfo();

        self.isLoaded = true;
        self.minSize = response.companySize?.min;
        self.maxSize = response.companySize?.max;
      } catch (e) {
        logger.warn('couldn\'t fetch user\'s company info');
      }
    }
  }),
});

export default Actions;
